import React from "react";

// Lightweight SEO component — injects meta tags into document.head
// (Use react-helmet-async for full SSR support if you add Next.js later)
export default function SEO({ title, description, image, url, type = "website" }) {
  const siteName = "Afriport Store";
  const fullTitle = title ? `${title} — Afriport Store` : siteName;
  const desc = description || "Quality household items, lifestyle essentials, and solar energy solutions for Nigerian homes and businesses.";
  const img = image || "/images/Afriportstore.png";
  const canonical = url || window.location.href;

  // Directly mutate document.head (works for SPA)
  React.useEffect(() => {
    document.title = fullTitle;
    setMeta("description", desc);
    setOG("title", fullTitle);
    setOG("description", desc);
    setOG("image", img);
    setOG("url", canonical);
    setOG("type", type);
    setOG("site_name", siteName);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", desc);
    setMeta("twitter:image", img);
  }, [fullTitle, desc, img, canonical, type]);

  return null;
}

function setMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

function setOG(property, content) {
  let el = document.querySelector(`meta[property="og:${property}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute("property", `og:${property}`); document.head.appendChild(el); }
  el.setAttribute("content", content);
}
